import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function CtaBanner() {
  return <section className="py-24 bg-blue-600 relative overflow-hidden" data-id="element-670">
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-671"></div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-672">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-673">
          Ready to replace Google Places API?
        </h2>
        <p className="text-xl text-white/80 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-674">
          Join thousands of developers who switched to the #1 Google Places API
          alternative. Get comprehensive local business data and a powerful
          local business search API — all in one platform.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-675">
          <Button href="http://app.openmart.com/register" variant="secondary" size="lg" arrow fullWidth className="sm:w-auto !text-blue-600" data-id="element-676">
            Try for free
          </Button>
        </div>
      </div>
    </section>;
}